<template>
    <div>


            <!-- <Chips v-for="(chip, index) in chips(item.assetId)" :key="index" :chipText="chip.text" :ChipsColor="chip.color"/> -->
            <template v-for="(chip, index) in chips(item.assetId)">
                <template v-if="chip.text === 'processing'">
                    <v-progress-circular
                        :key="index"
                        :rotate="180"
                        :size="40"
                        :width="6"
                        :value="chip.percent"
                        >
                        <span style="font-size: 12px;">{{ chip.percent }}%</span>
                    </v-progress-circular>
                </template>
                <template v-else>
                    <Chips :key="index" :chipText="chip.text" :ChipsColor="chip.color" class="mr-1"/>
                </template>
            </template>

        </div>

</template>

<script>
import Chips from '@/components/ui/chips/Chips.vue';
import { mapState } from 'vuex';

export default {
    components: {
        Chips,
    },
    props: {
        items: {
        type: Array,
        required: true
        },
        loading: {
        type: Boolean,
        required: true
        },
        search: {
        type: String,
        required: true
        },
        rowsPerPage: {
        type: Number,
        required: true
        },
        enterSelect: {
        type: Function,
        required: true
        },
        value: {
        type: Array,
        required: true
        },
        rowClick: {
        type: Function,
        required: true
        },
    },
    data() {
        return {
           result: {},
           flag: null,
        }
    },
    mounted() {
        // this.flag = false;
        // if(this.items && this.dataLoad){
        //     this.flag = true;
        // }
    },
    computed: {
        ...mapState('asset', ['dataLoad']),
        chips() {
            return (id) => {
                if(this.dataLoad && this.tableDatas){
                    return this.getChipData(id);
                    // if(!this.result[id]){
                    //     this.getChipData(id);
                    // }
                    // return this.result[id];
                }
                else {
                    return null;
                }
                // if(!this.result[id]){
                //     this.getChipData(id);
                // }
                // return this.result[id];
               
            }
        },
        tableDatas(){
           if(this.dataLoad && this.items){
                return this.items;
           }
           return this.items;
        }
    },
    methods: {
        getImage(src){
            if (src && src.trim() !== "") {
                return src;
            } else {
                return "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png";
            }
        },
        infoClick(val){
            // this.$emit('rowClick');
            this.rowClick(val);
        },
        updateType(val) {
            return val.toString().split(" ")[0];
        },
        // enterSelect(value) {
            
        //     console.log("dd => ", value)
        //     this.$emit('input', value); 
        // },
        // flattenAndCompare(arr1, arr2) {
        //     const flattenedArr2 = (arr2.map(e=>e.encoding_type)).flat();  
        //     console.log("flat => ", flattenedArr2)
        //     return arr1.filter(item1 => !flattenedArr2.includes(item1)); 
        // },
        saveInfo(id, result){
            // this.result[id] = result;
            this.$set(this.result, id, result);

            // console.log("saveInfo 확인 => ", this.result)
        },
        getChipData(id) {

            const result = [];
            // const datas = this.tableDatas.map(e => e.sortOut);
            // const data = datas.map(e => e).reduce((acc, curr) => acc.concat(curr), []);  // datas.flatMap(e => e);
            // const filter = data.filter(e => e.origin_asset_id === id);
            const datas = this.tableDatas.map(e => e.encodingInfo);
            const data = datas.map(e => e).reduce((acc, curr) => acc.concat(curr), []);  // datas.flatMap(e => e);
            const filter = data.filter(e => e.origin_asset_id === id);
            // const filteredData = filter.map(e => e);
            // console.log("필터링 데이터 2=> ", filter)

            const res = filter.map(e => {
                const text = e.status.match(/^processing\s/) ? 'processing' : this.updateType(e.type);
                const color = e.status === 'encoded' ? 'black' : '!black';
                const percent = e.status.match(/^processing\s/) ? (e.percent ? e.percent : null) : null;

                return {
                    text: text,
                    color: color,
                    percent: percent
                };
            });

            result.push(...res);

            // console.log("res =====> ", result)


            return result;
        },

    },
}
</script>

<style scoped>

</style>